const settings = {
    isProduction: true,
}

export function setConfig(params: { environment: string }) {
    settings.isProduction = params.environment === 'production'
}

// Страница, на которой компонент

type Page =
    | 'checkout'
    | 'confirmation'
    | 'register'
    | 'login'

// Блок/виджет, в котором компонент

type Block =
// common blocks
    | 'header'
    | 'footer'
    | 'loginForm'
    | 'headline'
    | 'buttonTabs'
    | 'table'
    | 'confirmationModal'
    | 'breadcrumb'
    // B2B workspace Page
    | 'workspaceList'
    | 'searchProductPanel'
    | 'searchProductResult'
    | 'foundProductBrandsTabs'
    | 'foundProductCard'
    | 'workspaceBottomline'
    | 'workspaceTab'
    | 'cartShoppingControls'
    | 'renameCartModal'
    | 'requestModal'
    // Checkout
    | 'shipping_address'
    | 'transit_address'
    | 'billing_address'
    | 'paymentMethods'
    | 'shippingMethods'
    | 'shippingMethod'
    | 'cartSidebar'
    | 'cartTotals'
    | 'couponListItem'
    | 'couponList'
    // Confirm
    | 'confirmationDetails'
    | 'totalsList'
    // B2C
    | 'productCard'
    | 'test-ci-9'

/**
 * modifier - это поле применяют для пробрасывания уникального параметра в списке одинаковых страниц/блоков/элементов
 * Например, отображаются табы и мы знаем что у каждого таба есть уникальное поле title (название таба).
 * Допустим для таба "profile-userInfoTabs-tab"
 * И таких табов три: 'Main data', 'Change password', 'Notifications'.
 * И в таком случае будет очень удобно пробрасывать title в modifier
 * "profile-userInfoTabs-tab--MainData"
 * "profile-userInfoTabs-tab--ChangePassword"
 * "profile-userInfoTabs-tab--Notifications"
 * **/

export type ElmParams = {
    page?: Page,
    block?: Block,
    elm: string,
    modifier?: string
};

// For test CI 9

export type BlockParams = {
    page?: Page,
    block: Block,
    modifier?: string,
};

export type PageParams = {
    page: Page,
    modifier?: string,
};

type commonType = ElmParams &
    BlockParams &
    PageParams;
type keyType = keyof commonType;


export function testid(parameters: ElmParams | BlockParams | PageParams, returnString: true): string;
export function testid(
    parameters: ElmParams | BlockParams | PageParams,
): { "data-testid"?: string };
export function testid(
    parameters: ElmParams | BlockParams | PageParams,
    returnString?: boolean
): { "data-testid"?: string } | string {

    if (settings.isProduction) {
        return returnString ? '' : {};
    }

    const parts = [];
    const keys: keyType[] = [
        'page',
        'block',
        'elm'
    ];
    for (const key of keys) {
        // @ts-expect-error union parsing error
        if (!!parameters[key] && typeof parameters[key] === 'string' && parameters[key]?.length > 0) {
            // @ts-expect-error union parsing error
            parts.push(parameters[key]);
        }
    }

    const res = parameters?.modifier
        ? `${parts.join('-')}--${parameters.modifier}`
        : parts.join('-');

    return returnString ? res : {"data-testid": res};
}

export function combineId(otherProps: {
    [key: string]: any,
    "data-testid"?: string
}, defaultValue?: ElmParams | BlockParams | PageParams) {

    if (otherProps['data-testid']) {
        return {'data-testid': otherProps['data-testid']};
    }

    if (defaultValue) {
        return testid(defaultValue)
    }

    return {};
}

